module.exports = __webpack_public_path__ + "media/images/lavita_banner/composed_banner/banner__sponsor__bottle--en-56b1a1a46032a9c7eacbd1d4f36dc2e8.png";